<template>
  <section class="content__listing__container">
    <h2 class="content__listing__container__heading">
      {{ searchTranslate() }} ({{ store.getVisibleContents.length }})
    </h2>
    <transition-group name="fade" mode="out-in">
      <ContentBox class="content_listing__content"
        v-for="content in store.getVisibleContents" :key="content.id"
        :content="content" />
    </transition-group>
    <transition name="fade" mode="out-in">
      <h2 class="no__results" v-if="store.getVisibleContents.length === 0">
        {{ noResultsTranslate() }}
      </h2>
    </transition>
  </section>
</template>

<script>
import { useContentStore } from "@/store/content";
import ContentBox from "@/components/ContentBox.vue";

export default {
  name: "ContentListing",
  components: {
    ContentBox,
  },
  setup() {
    const store = useContentStore();
    function searchTranslate() {
      return window.Drupal.t("Search Results");
    }
    function noResultsTranslate() {
      const translations = {
        "agents" : window.Drupal.t("No agents in the selected area."),
        "workshops" : window.Drupal.t("No workshops in the selected area."),
      }
      return translations[store.contentType];
    }
    return {
      store,
      searchTranslate,
      noResultsTranslate,
    };
  },
};
</script>